import { DimTree } from '@/common/entityFramework/entityPerspective/support/DimTree';
import { useFormFieldDef } from '../hooks/useFormFieldDef';

// TODO: Consolidate this with DimTree and leverage Form in EntityPerspective
export const TreeSelect = ({ fieldDef }) => {
  const { value, setValue, label, disabled } = useFormFieldDef(fieldDef);
  
  return (
    <DimTree
      displayName={label}
      disabled={disabled}
      treeData={fieldDef.treeData}
      selectedIds={value || []}
      onFilterChange={(newSelectedIds) => setValue(newSelectedIds)}
    />
  )
}